module.exports = __webpack_public_path__ + "static/media/CommentInput_RECORD.2371255b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CommentInput_RECORD.png
// module id = 286
// module chunks = 0